<div class="eventi">
    <nav>
        <ul class="nav-wrapper">
            <li><a mat-raised-button color="primary" [routerLink]="['/bacheca']">{{'Bacheca'|translate}}</a></li>
        </ul>
    </nav>
    <div *ngIf="eventi.length>0"  class="evento">
        <!--h4>Categorie</h4-->
        <div class="lista" fxLayout="row wrap" fxLayoutAlign="none stretch">

            <mat-card  *ngFor="let m of eventi">
                <mat-card-header>
                    <mat-card-title>{{m.data}}</mat-card-title>
                    <mat-card-subtitle>{{m.titolo}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>{{m.body}}</mat-card-content>
                <mat-card-footer *ngIf="m.files && m.files.length>0">
                    <div *ngFor="let y of m.files" >
                        <div class="top"><a target="_blank" href="{{y.url}}">{{y.nome}}</a><span class="size">[{{y.size}}]</span></div>
                        <div *ngIf="y.descrizione" class="det2">{{y.descrizione}}</div>
                    </div>
                </mat-card-footer>
            </mat-card>

        </div>
    </div>
</div> 


// WEBPACK FOOTER //
// ./src/app/tws-bacheca/tws-bacheca.component.html